export enum KYC_PHOTO_STATUSES {
    SUCCESS = 'SUCCESS',
    DEVIATION = 'DEVIATION',
    REJECTED = 'REJECTED'
}

export enum KYC_PRE_SIGNED_URL_UPLOAD_STATUSES {
    SUCCESS = "success",
    FAILURE = "failure"
}